import React, {Component} from 'react';
import {connect} from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import {getCookie, eraseCookie, CookieName} from '../utils/cookieManager';
import {withStyles} from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import {resetStore} from '../actions/main';
import {LOCALSTORAGE_KEY} from '../utils/constants.js';

const styles = {
  bigAvatar: {
    margin: 10,
    width: 100,
    height: 100,
  },
};

class Profile extends Component {
  constructor(props) {
    super(props);
    this.logout = this.logout.bind(this);
  }

  componentDidMount() {
    if (!getCookie(CookieName.USERTOKEN)) {
      this.props.reset();
    }
  }

  logout() {
    if (getCookie(CookieName.LOGINTYPE) === CookieName.GOOGLE) {
      const auth2 = window.gapi.auth2.getAuthInstance();
      if (auth2) {
        auth2.signOut();
      }
    }
    eraseCookie(CookieName.USERTOKEN);
    eraseCookie(CookieName.USERTEMPTOKEN);
    eraseCookie(CookieName.USERIMG);
    eraseCookie(CookieName.USERNAME);
    eraseCookie(CookieName.USEREMAIL);
    eraseCookie(CookieName.USERMOBILE);
    localStorage.setItem(LOCALSTORAGE_KEY.SAVED_DATA, JSON.stringify({}));
    this.props.reset();
    window.location.reload();
  }

  render() {
    const logoutBtn = (
      <Button
        variant="contained"
        className="ctkt-btn-success"
        onClick={this.logout}
      >
        LOG OUT{' '}
      </Button>
    );

    const uMobile = getCookie(CookieName.USERMOBILE);

    return (
      <div className="profile">
        <Grid container justifyContent="center" alignItems="center">
          <div>
            <Avatar
              alt="Profile"
              src={getCookie(CookieName.USERIMG)}
              className={this.props.classes.bigAvatar}
            />
          </div>
        </Grid>

        <div className="userinfo">
          <div className="name">{getCookie(CookieName.USERNAME)}</div>
          <div className="email">{getCookie(CookieName.USEREMAIL)}</div>

          <div className="phone">
            {uMobile && uMobile.length >= 10 ? uMobile : ''}
          </div>
        </div>

        {logoutBtn}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    reset: () => {
      dispatch(resetStore());
    },
  };
};

Profile.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Profile));
